<template>
  <div class="openlecture-wrapper" v-if="dataDone">
    <div class="baseinfo-container">
      <div class="title">{{courseData.title}}</div>
      <div class="date">{{courseData.formatTime}}</div>
      <div class="author-info" v-if="courseData.teacher_info && courseData.teacher_info.length > 0">
        <div class="author-title">主讲人</div>
        <div class="author-list">
          <div class="item" v-for="(item, index) in courseData.teacher_info" @click="toTeacherDetail(item.uid)" :key="index">
            <div class="avatar lazy-load">
              <img class="" :src="item.avatar" v-if="item.uid != 0">
              <img class="" :src="item.avatar" v-else>
            </div>
            <div class="teacher-info">
              <div class="name">{{item.name}}</div>
              <div class="title-info">
                <div>{{item.title1}}</div>
                <div>{{item.title2}}</div>
              </div>
            </div>
            <div class="link-arrow" v-if="item.uid != 0">讲师详情<icon icon-class="arrow-right"></icon></div>
          </div>
        </div>
      </div>
    </div>
    <div class="studio-cover">
      <div class="video-title">凯诺公开课实录 <img src="/Application/Home/Resource/static/images/mobile/video-arrow.png"></div>
      <div class="video-box">
        <img :src="courseData.thumb" v-if="!courseData.url">
        <video-player :src="courseData.url" :poster="courseData.thumb" v-else></video-player>
      </div>
    </div>
    <div class="course-main-wrapper">
      <div class="tab-wrapper" ref="courseTab">
        <div class="course-tab" :class="{'fixed': tabFixed}">
          <div class="tab-item" :class="{'active': activeTab == 'info'}" @click="tab('info')">课程信息</div>
        </div>
      </div>
      <div class="course-info-main" v-if="activeTab == 'info'">
        <div class="course-block">
          <div class="info-content">
            <div class="rich-text" v-html="courseData.content"></div>
          </div>
        </div>
      </div>
      <!-- 其他课程 -->
      <div class="about-openlecture" ref="aboutCourse">
        <div class="about-title">
          <div class="title">更多公开课</div>
          <div class="reload-about" @click="toAllOpenlecture">查看全部 <icon icon-class="arrow-right"></icon></div>
        </div>
        <div class="about-list" v-if="courseData.other_info.length > 0">
          <router-link :to="{name: 'publicClassDetail', params: {id: item.id}}" class="about-card" v-for="item in courseData.other_info" :key="item.id">
            <div class="course-cover lazy-load"><img :src="item.thumb" alt=""></div>
            <div class="course-info">
              <div class="about-course-title">{{item.title}}</div>
            </div>
          </router-link>
        </div>
      </div>
      <!-- 底部操作 -->
      <div class="workshop-control">
        <!-- 分享 -->
        <div class="control-item share" @click="share">
          <icon icon-class="new-share"></icon>
          <div class="control-text">分享</div>
        </div>
      </div>
      <share :src="locationHref" :title="courseData.title" type="公开课" ref="shareComponent"></share>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .openlecture-wrapper{
    width: 100%;
    position: relative;
    padding-bottom: 48px;
    &.iphonex{
      padding-bottom: 67px;
    }
    .baseinfo-container{
      padding: 17px 16px 0 16px;
      .title{
        font-size: 22px;
        line-height: 28px;
        font-weight: bold;
        color: #333;
      }
      .date{
        margin-top: 12px;
        font-size: 14px;
        line-height: 14px;
        color: #666;
      }
      .author-info{
        padding-top: 32px;
        .author-title{
          font-size: 14px;
          line-height: 14px;
          font-weight: bold;
          color: #333;
        }
        .author-list{
          padding-top: 4px;
          .item{
            position: relative;
            padding: 16px 0;
            border-bottom: 1px solid #F6F7F8;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            &:last-child{
              border-bottom: 0;
            }
            .avatar{
              width: 62px;
              height: 62px;
              border-radius: 50%;
              overflow: hidden;
              flex-shrink: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .teacher-info{
              flex: 1;
              padding-left: 12px;
              .name{
                font-size: 14px;
                line-height: 14px;
                color: #666;
                font-weight: bold;
              }
              .title-info{
                margin-top: 8px;
                font-size: 12px;
                line-height: 18px;
                color: #666;
              }
            }
            .link-arrow{
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #4DA2C7;
              svg{
                font-size: 10px;
                margin-left: 5px;
              }
            }
          }
        }
      }
    }
    .studio-cover{
      position: relative;
      width: 100%;
      padding-top: 12px;
      .video-title{
        margin-top: 16px;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 14px;
        color: #333;
        padding-left: 16px;
        font-weight: bold;
        img{
          width: 14px;
          margin-left: 8px;
        }
      }
      .video-box{
        margin-top: 16px;
        width: 100%;
        height: 2rem;
        background: #EEE;
        overflow: hidden;
        img{
          width: 100%;
          transform: translateY(-16%);
        }
      }
      &.status-bar{
        padding-bottom: 34px;
      }
      .cover-info{
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 34px;
        background: @cano;
        color: #FFF;
        padding: 0 16px;
        font-size: 14px;
        &.soon{
          background: #F85C5C;
        }
        .cover-tips{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          svg{
            margin-right: 6px;
            font-size: 12px;
          }
        }
      }
    }
    .course-main-wrapper{
      padding-top: 20px;
      .tab-wrapper{
        height: 34px;
        .course-tab{
          box-sizing: border-box;
          padding: 0 16px;
          background: #FFF;
          border-bottom: 1px solid #EEEEEE;
          height: 34px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          &.fixed{
            position: fixed;
            top: 87px;
            left: 0;
            width: 100%;
            z-index: 99;
          }
          .tab-item{
            position: relative;
            height: 34px;
            line-height: 34px;
            font-size: 14px;
            color: #999;
            margin-right: 16px;
            &.active{
              color: #333;
              font-weight: bold;
              &::after{
                content: '';
                position: absolute;
                left: 50%;
                bottom: 0;
                width: 24px;
                height: 3px;
                border-radius: 2px;
                background: @cano;
                transform: translateX(-50%);
              }
            }
          }
        }
      }
      .course-info-main{
        padding: 18px 12px 7px;
        .course-block{
          font-size: 14px;
          color: #888888;
          line-break: 17px;
        }
      }

      .about-openlecture{
        border-top: 10px solid #F3F3F3;
        padding: 24px;
        .about-title{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title{
            font-size: 18px;
            line-height: 18px;
            color: #333;
            font-weight: 600;
          }
          .reload-about{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: @cano;
            cursor: pointer;
            font-size: 14px;
            line-height: 14px;
            svg{
              font-size: 12px;
              margin-left: 4px;
            }
          }
        }
        .about-list{
          margin-top: 16px;
          .about-card{
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            height: .8rem;
            box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
            border-radius: 6px;
            overflow: hidden;
            .course-cover{
              flex-shrink: 0;
              width: .97rem;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              img{
                height: 100%;
              }
            }
            .course-info{
              padding: .16rem 0 0 12px;
              flex: 1;
              min-width: 0;
              .about-course-title{
                font-size: 15px;
                line-height: 22px;
                color: #333;
                font-weight: 500;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 2rem;
              }
            }
          }
        }
      }
    }
    /* 小组课底部操作 */
    .workshop-control{
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      width: 100%;
      height: 48px;
      border-top: 1px solid #BDBDBD;
      background-color: #fff;
      z-index: 990;
      &.iphonex{
        height: 67px;
      }
      .control-item{
        position: relative;
        box-sizing: border-box;
        // flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 48px;
        background-color: transparent;
        border: 0;
        color: #333;
        padding: 0 36px;
        .control-text{
          font-size: 12px;
          margin-left: 8px;
        }
      }
    }
  }
</style>

<script>
  import Utils from '@/untils/utils'
  import VideoPlayer from '@/components/Common/videoPlayer.vue'
  import share from '@/components/Common/share.vue'
  export default {
    data() {
      return {
        dataDone: false,
        courseData: null,
        // 当前tab
        activeTab: 'info',
        // tab顶部偏移值
        tabOffset: 0,
        tabFixed: false,
        locationHref: '',
      }
    },
    components: {
      VideoPlayer,
      share
    },
    created() {
      this.$store.commit('setActiveMenu', 'article');
      this.locationHref = window.location.href;
      this.$root.post('/Course/get_video_detail', {
        id: this.$route.params.id
      }).then(data => {
        console.log(data);
        this.dataDone = true;
        this.courseData = data;
        this.$nextTick(() => {
          this.getTabOffset();
          $(document).scroll(() => {
            let scrollTop = $(document).scrollTop()
            this.tabFixed = (scrollTop >= this.tabOffset) ? true : false;
          })
        })
      })
    },
    methods: {
      // 获取切换tab的顶部偏移值
      getTabOffset() {
        this.tabOffset = this.$refs.courseTab.offsetTop;
      },
      toTeacherDetail(id) {
        if(id == 0) return;
        this.$router.push({name: 'LecturerDetail', params: {id: id}});
      },
      toAllOpenlecture() {
        // 查看全部公开课
        this.$router.back();
      },
      share() {
        this.$refs.shareComponent.showMenu();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CourseDetail/publicClass.vue